import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OrderService } from "src/app/core/services/order.service";
import { OOVenueService } from "src/app/core/services/venue-service";

@Component({
	selector: "app-check-out",
	templateUrl: "./check-out.component.html",
	styleUrls: ["../online-order.component.scss"],
})
export class CheckOutComponent implements OnInit {
	loaded: boolean = false;
	constructor(public venueService: OOVenueService, public orderService: OrderService, private focuslink: FocuslinkService, private route: ActivatedRoute) {}

	ngOnInit(): void {
		const venueKey = +this.route.snapshot.paramMap.get("storeKey");
		this.venueService.subscriptionOOvenue.subscribe((data) => {
			if (data.venueKey) {
				this.loaded = true;
			}
		});

		if (!this.venueService.subscriptionOOvenue.value.venueKey) {
			this.venueService.ooVenueGet(venueKey);
		}
	}
}
